import { useNotification } from '@/layers/presentation/context/NotificationContext';
import { ToastOptions } from 'react-toastify';
import { NotificationType } from '@/types/modelEnums';

export const useThrowNotification = () => {
  const { handleNotification } = useNotification();

  const throwNotification = (
    type: NotificationType,
    message: string,
    context: Record<string, any> = {},
    options?: ToastOptions,
  ) => {
    try {
      handleNotification(type, message, context, options);
    } catch (notification) {
      console.error('Error in throwNotification:', notification);
    }
  };

  return throwNotification;
};
